import styled from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0px 1px 3px 0px var(--gray);
  width: 100%;
  border-radius: 4px;
  padding: 0 8px;

  * {
    color: var(--gray) !important;
  }

  & .icon {
    padding: 0 4px;
  }

  input {
    padding: 12px 0px;
    background: transparent;
    border: none;
    outline: none;
    font-size: 1rem;
    width: 100%;

    ::placeholder {
      font-size: 0.9em;
    }
  }
`;

export { InputContainer };
